import LabelAsPlaceholder from './label-as-placeholder'

export default LabelAsPlaceholder
